import { Box, Button, SxProps, Theme, Typography } from "@mui/material";

type Props = {
  prompt: string;
  confirmLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
  size?: "small" | "medium";
  sx?: SxProps<Theme>;
};

// "<prompt> Cancel / <confirm>" in place of a destructive button, instead of a dialog-on-dialog.
// Fills its container with the prompt on the left and the buttons on the right, so it drops straight
// into DialogActions or a list row's secondary action.
const InlineConfirm = ({ prompt, confirmLabel, onCancel, onConfirm, size = "medium", sx }: Props) =>
  <Box sx={[{ display: "flex", alignItems: "center", gap: 1, width: "100%" }, ...(Array.isArray(sx) ? sx : [sx])]}>
    <Typography variant="body2" color="text.secondary" sx={{ mr: "auto" }}>{prompt}</Typography>
    <Button color="inherit" size={size} onClick={onCancel}>Cancel</Button>
    <Button color="error" variant="contained" size={size} onClick={onConfirm}>{confirmLabel}</Button>
  </Box>;

export default InlineConfirm;
